// DS9.8.1
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import { Url } from '@wix/da-url';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import CheckIcon from '@wix/da-ds/pkg/Icons/16x16/Check';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import Avatar from '../../User/Avatar';
import BasicUserName from '../../User/BasicUserName';
import SubscriberStat from '../../Stats/SubscriberStat';
import TierPriceWithBadge from '../Helper/TierPriceWithBadge';
import MinimalDumbo from '../Dumbo/MinimalDumbo';
import { getTierDescription } from '../_helpers';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useDeviationMatureFilter } from '../../utils/hooks/useDeviationMatureFilter';
import HiddenOverlay from '../HiddenOverlay';
import s from './TierSidebarCard.scss';
var TierSidebarCard = function (_a) {
    var deviation = _a.deviation, biData = _a.biData, className = _a.className;
    var t = useTranslation().t;
    var deviationId = deviation.deviationId, author = deviation.author, title = deviation.title;
    var _b = deviation.tier || {}, dollarPrice = _b.dollarPrice, isUserSubscribed = _b.isUserSubscribed;
    var matureTiers = useFlag('mature_tiers');
    var _c = useDeviationMatureFilter(deviation), showBlocked = _c.showBlocked, overrideMatureFilter = _c.overrideMatureFilter;
    var onOverrideFilterClick = useCallback(function (e) {
        overrideMatureFilter();
        e.stopPropagation();
    }, [overrideMatureFilter]);
    if (!(author === null || author === void 0 ? void 0 : author.username) || !dollarPrice) {
        return null;
    }
    var coverWidth = 274;
    var coverHeight = 152;
    var href = isUserSubscribed
        ? Url.userSubscriptionsPath({
            username: author.username,
            tierDeviationId: deviationId,
            tierContentType: 'deviations',
            anchor: true,
        })
        : Url.deviationLink(deviationId, author.username, title);
    var description = getTierDescription(deviation);
    return (React.createElement(PlainButtonOrLink, { className: classnames(s['root'], className), biData: biData, href: href },
        matureTiers && showBlocked && (React.createElement(HiddenOverlay, { className: s['card-overlay'], showBackground: false, deviation: deviation, overrideMatureFilter: onOverrideFilterClick })),
        React.createElement("div", { className: s['user-info'] },
            React.createElement(Avatar, { user: author, size: 24, withLink: false }),
            React.createElement(BasicUserName, { usernameClassName: s['username'], symbolClassName: s['user-symbol'], user: author }),
            isUserSubscribed && (React.createElement("span", { className: s['subscribed'] },
                React.createElement(CheckIcon, { className: s['subscribed-icon'], size: IconSize.SMALLER }),
                ' ',
                t('deviation.tier.subscribed')))),
        deviation.coverImage ? (React.createElement(MinimalDumbo, { className: s['cover'], deviation: deviation.coverImage, height: coverHeight, width: coverWidth })) : (React.createElement("div", { className: classnames(s['cover'], s['placeholder-cover']), style: { width: coverWidth, height: coverHeight } })),
        title && React.createElement(Heading, { className: s['title'] }, title),
        React.createElement(SubscriberStat, { className: s['subscribers'], deviation: deviation }),
        description && React.createElement("div", { className: s['description'] }, description),
        React.createElement(Flex, { alignItems: "center" },
            React.createElement(TierPriceWithBadge, { className: s['price'], price: dollarPrice }))));
};
TierSidebarCard.displayName = 'TierSidebarCard';
export default TierSidebarCard;
//# sourceMappingURL=TierSidebarCard.js.map